<template>
  <v-container
    v-if="!store.state.global.isLoggedIn"
    class="d-flex align-center justify-center"
    :style="{ height: '85vh' }"
  >
    <v-card class="w-full pa-2">
      <div class="d-flex py-3 justify-space-between">
        <form @submit.prevent="onSubmit">
          <v-container>
            <v-row>
              <v-img
                height="60"
                src="/img/brelag/styler.png"
                class="text-white my-4"
              ></v-img>
            </v-row>
            <v-row>
              <v-text-field
                v-model="username.value.value"
                autocomplete="username"
                width="400px"
                :error-messages="username.errorMessage.value"
                label="Benutzername"
                color="primary"
              ></v-text-field>
            </v-row>
            <v-row>
              <v-text-field
                v-model="password.value.value"
                type="password"
                autocomplete="current-password"
                :error-messages="password.errorMessage.value"
                label="Passwort"
                color="primary"
              ></v-text-field>
            </v-row>
            <v-row class="my-2">
              <router-link
                style="opacity: 0.5"
                :to="{ name: 'reset_password' }"
                >{{ $t('models.auth.forgotPassword') }}</router-link
              >
            </v-row>
            <v-row class="my-2">
              <router-link
                style="opacity: 0.5"
                :to="{ name: 'activate_profile' }"
                >{{ $t('models.auth.activateAccount') }}</router-link
              >
            </v-row>
            <v-row>
              <v-alert
                v-if="wrongLogin"
                density="compact"
                type="error"
                :text="errorMessage"
              ></v-alert>
              <v-divider></v-divider>
            </v-row>
            <v-row align="center" justify="center">
              <v-btn-group class="my-4">
                <v-btn type="submit" width="125" color="primary">Login</v-btn>
              </v-btn-group>
            </v-row>
          </v-container>
        </form>
      </div>
    </v-card>
  </v-container>
</template>

<script setup lang="ts">
import axios from 'axios'
import { CookieStorage } from 'cookie-storage'
import { useField, useForm } from 'vee-validate'
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

const store = useStore()
const router = useRouter()
const wrongLogin = ref(false)
const errorMessage = ref('')

interface FormData {
  username: string
  password: string
}

const { handleSubmit } = useForm({
  validationSchema: {
    username(value) {
      if (value?.length >= 2) return true
      return 'Name needs to be at least 2 characters.'
    },
    password(value) {
      if (value?.length >= 2) return true
      return 'Password needs to be at least 2 characters.'
    },
  },
})

// This must come after useForm ?!
const username = useField('username')
const password = useField('password')

const onSubmit = handleSubmit((values) => {
  login(values as FormData)
})

onMounted(() => {
  if (store.state.global.isLoggedIn) {
    redirectUser()
  }
})

const redirectUser = () => {
  let url = '/'
  if (router.currentRoute.value.query.afterLoginUrl) {
    url = router.currentRoute.value.query.afterLoginUrl as string
  }
  router.push({ path: url })
}

const login = async (values: FormData) => {
  try {
    const response = await axios.post('/api/v1/auth/login', values)

    // Successful login
    const cookieStorage = new CookieStorage()
    const csrf = cookieStorage.getItem('csrftoken')
    response.data.csrfToken = csrf
    store.dispatch('global/loginUser', { data: response.data }).then(() => {
      redirectUser()
    })
  } catch (error) {
    errorMessage.value = Array.isArray(error.response.data)
      ? error.response.data.at(0)
      : 'Es ist ein Fehler aufgetreten'
    wrongLogin.value = true
  }
}

// ...mapGetters('global', ['registrationEnabled']),
</script>

<style lang="scss">
.second-button {
  margin-left: 15px;
}
</style>
